<template>
    <v-card>

        <v-card-text>

            <v-textarea v-model="messageModel"
                        solo
                        :loading="sending"
                        background-color="grey darken-2"
                        placeholder="Send a message"
                        rows=2
                        hide-details
                        autofocus
                        @keydown.enter.prevent="sendMessage"
            ></v-textarea>

        </v-card-text>

        <chat-bubble-list :messages="privateMessages['user_' + user.id]"/>

    </v-card>
</template>

<script>

import ChatBubbleList from "./ChatBubbleList";
import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
import moment from 'moment';
import {timeDisplay} from "../../../components/mixins/timeDisplayMixin";

const vuexModule = 'Chat';

export default {

    mixins: [timeDisplay],

    components: {
        ChatBubbleList,
    },

    props: {
        user: {
            type: Object,
            required: true,
        },

        visible: {
            type: Boolean,
            required: true,
        }
    },

    data() {
        return {
            messageModel: '',
            sending: false,
        }
    },

    watch: {
        visible() {
            this.setPrivateMessagesSeen(this.user);
        },
    },

    computed: {
        ...mapState(['echo']),

        ...mapState(vuexModule, [
            'privateMessages'
        ]),


        panelUuid() {
            if (this.$store.state.PanelSettings.settings.uuid) {
                return this.$store.state.PanelSettings.settings.uuid;
            }
        },

        currentUser() {
            if (this.$store.state.user) {
                return this.$store.state.user;
            }
        },
    },

    mounted() {
        this.initializePrivateMessages();
    },

    methods: {

        ...mapActions(vuexModule, [
            'sendPrivateMessage'
        ]),

        ...mapMutations(vuexModule, [
            'addPrivateMessage',
            'setPrivateMessagesSeen',
            'initializePrivateMessages'
        ]),

        showDateBoundary(createdAt) {
            let showDivider = moment(createdAt).isBefore(this.previousDate);
            this.previousDate = moment('' + createdAt);
            return showDivider;
        },

        sendMessage() {

            if (!this.messageModel) return;

            this.sending = true;

            this.sendPrivateMessage({
                user: this.user,
                message: this.messageModel
            })
                .then(() => {
                    this.addPrivateMessage({
                        message: this.messageModel,
                        user: {
                            id: this.currentUser.id,
                            name: this.currentUser.name,
                            photo_url: this.currentUser.photo_url,
                        },
                        set: this.$set,
                        receiver: this.user.id
                    });

                    const audio = new Audio('/sounds/privatemessage.mp3');
                    audio.volume = 0.3;
                    audio.play();

                    this.messageModel = '';
                })
                .catch(() => {
                    Bus.$emit('flash-message', {
                        type: 'error',
                        message: 'We are sorry you message failed to send. Try again later.'
                    });
                })
                .finally(() => {
                    this.sending = false;
                });
        }

    }
}

</script>
